import { SVGProps } from 'react';

export const Add = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6.33333H7.66667V1H6.33333V6.33333H1V7.66667H6.33333V13H7.66667V7.66667H13V6.33333Z"
      fill="currentColor"
    />
  </svg>
);
